import { render, staticRenderFns } from "./MultiYSMonitor.vue?vue&type=template&id=bc816cc0&scoped=true"
import script from "./MultiYSMonitor.vue?vue&type=script&lang=js"
export * from "./MultiYSMonitor.vue?vue&type=script&lang=js"
import style0 from "./MultiYSMonitor.vue?vue&type=style&index=0&id=bc816cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc816cc0",
  null
  
)

export default component.exports